export default __webpack_public_path__ + "6a148a0f746d4ca697cca7d8f2cb6d98.png";